import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import PropTypes from 'prop-types';
import moment from 'moment';
import { monthWithDays } from '../helper';
import { setCurrencyFormat } from '../../../utils/helpers';


const PromotionPrimeBarChart = ({ height, dataToShowForDatesSelected }) => {
    const thisMonthData = {};

    dataToShowForDatesSelected.forEach((item) => {
        const date = moment(item.date, 'MMM-D-YYYY');
        const dateWithMonthYear = moment(item.date).format('MMM-YYYY-DD');

        if (item.date && thisMonthData[dateWithMonthYear]) {
            thisMonthData[dateWithMonthYear].push(item)
        } else {
            thisMonthData[dateWithMonthYear] = [item]
        }

    })

    const reduceCallback = (acc, item) => acc + Number(item.totalPromotedRevenue)
    const reduceCallbackForQty = (acc, item) => acc + Number(item.totalPromotedQuantity)
    const dataToPlot = []

    Object.keys((thisMonthData)).forEach((dayMonthYear) => {
        const [day, month, year, dayofyear] = dayMonthYear.split('-');

        const currentMonthAmount = thisMonthData?.[dayMonthYear].reduce(reduceCallback, 0)
        const currentMonthDataKey = `${day}, ${month} ${year}`;

        dataToPlot.push({
            'Total Promoted Revenue': currentMonthAmount,
            "day": `${currentMonthDataKey}`,
        })
    })

    return (
        <ResponsiveContainer width="100%" height={height}>
            <BarChart
                width={500}
                height={300}
                data={dataToPlot}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
            >
                <CartesianGrid vertical={false} horizontal stroke="#FF0000" strokeWidth={2} />
                <XAxis dataKey="day" />
                <YAxis type="number" />
                <Tooltip formatter={value => setCurrencyFormat(Number(value).toFixed(2), true)} />
                <Legend />
                {/* <Bar dataKey={'Total Quantity'.toString()} fill="#82ca9d" /> */}
                <Bar dataKey={'Total Promoted Revenue'.toString()} fill="#8884d8" />

            </BarChart>
        </ResponsiveContainer>
    )
}

PromotionPrimeBarChart.propTypes = {

    height: PropTypes.number.isRequired,
    dataToShowForDatesSelected: PropTypes.arrayOf({}).isRequired,
    // eslint-disable-next-line react/forbid-prop-types
};

export default React.memo(PromotionPrimeBarChart);